import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';
import Autosuggest from 'react-autosuggest';
import { Modal, ModalBody, Row, Col, ModalFooter } from 'reactstrap';
import { getTotalPartners, getPartnerPaged, findpartnersendotplink, deActivatePartner,activatePartner, adminUser, movetoTrash, partnerApi, resetPasswordSend } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import Pagination from "react-js-pagination";
//import Pagination from 'rc-pagination';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

class partnerList extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
             
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location:  localStorage.getItem("location")? localStorage.getItem("location"):'Bengaluru',
              partnerList: [],
              exportbtndisabled:false,  
              PER_PAGE:15,
              total:0,
              loading:true,
              searchby:'',
              activePage:0,
              offset:0,
              thisExportBtnText:'Export',
              monthList: [{ no: 1, mon: 'Jan' }, { no: 2, mon: 'Feb' }, { no: 3, mon: 'Mar' }, { no: 4, mon: 'Apr' },
            { no: 5, mon: 'May' }, { no: 6, mon: 'Jun' }, { no: 7, mon: 'Jul' }, { no: 8, mon: 'Aug' },
            { no: 9, mon: 'Sep' }, { no: 10, mon: 'Oct' }, { no: 11, mon: 'Nov' }, { no: 12, mon: 'Dec' }],
        };

        
 
    }

 

    componentDidMount() {
        
        let THIS = this;
        $(document).on('click', '.extend', function () {
            console.log($(this).attr('id'));
            THIS.extenPeriod($(this).attr('id'), '2022-05-09');
        });
        $(document).on('click', '.remove_role', function () {
            var deact_id = $(this).data("id");
            THIS.disapproveuser(deact_id);
        });

        $(document).on('click', '.activate', function () {
          var deact_id = $(this).data("id");
          THIS.activateuser(deact_id);
        });

        $(document).on('click', '.trash', function () {
          var trash_id = $(this).data("id");
          THIS.trashit(trash_id);
        });

        $(document).on('click', '.resetpassword', function () {
          var trash_id = $(this).data("id");
          THIS.sendResetPassword(trash_id);
        });

        

        $(document).on('click', '.setDiscount', function () {

          var item_id = $(this).data("id");

          THIS.openSetDiscount(item_id);
          
        });

        $(document).on('click', '.sendOTPmail', function () {
            var add_id = $(this).data("id");
           
            THIS.sendOTPMail(add_id);
        });



      this.getTotal('partners');
      this.getList();

    }


    extenPeriod(vendor_id, expire_date){
      //let list = this.state.datalist;
      //let current = list.filter((item => item.vendor_id == id));
      //if (current.length > 0) {
          this.setState({
              confirmModal: true,
              expire_date: new Date(expire_date),
              vendor_id: vendor_id
          });
     // }
  }
  cancelPop = (e) => {
      e.preventDefault();
      this.setState({
          confirmModal: false,
          expire_date: '',
          vendor_id: 0
      });
  }

  sendResetPassword(id=''){
    if(confirm("Are you sure to reset password and send it to their email address?")== true) {
      let ins = JSON.stringify({
          id: id                
      });
      resetPasswordSend(ins).then((res) => {
          
          if (res.status === 1) {
              
              NotificationManager.success(res.message);
             
              
          } else {
              
              NotificationManager.error(res.message);
          }
      });
  }
  }
  
    
    trashit(deact_id = '') {
      if(confirm("Are you sure to move to trash?")== true) {
              let ins = JSON.stringify({
                  id: deact_id                
              });
              movetoTrash(ins).then((res) => {
                  
                  if (res.status === 1) {
                      
                      NotificationManager.success(res.message);
                      
                      setTimeout(function () {
                          window.location.reload();
                      }, 2000);
                      
                  } else {
                      
                      NotificationManager.error(res.message);
                  }
              });
          }
     }


     activateuser(activating_id = '') {
      if(confirm("Are you sure to activate this?")== true) {
              let ins = JSON.stringify({
                  id: activating_id                
              });
              activatePartner(ins).then((res) => {
                  
                  if (res.status === 1) {
                      
                      NotificationManager.success(res.message);
                      
                      setTimeout(function () {
                          window.location.reload();
                      }, 2000);
                      
                  } else {
                      
                      NotificationManager.error(res.message);
                  }
              });
          }
     }

    disapproveuser(deact_id = '') {
      if(confirm("Are you sure to deativate this?")== true) {
              let ins = JSON.stringify({
                  id: deact_id                
              });
              deActivatePartner(ins).then((res) => {
                  
                  if (res.status === 1) {
                      
                      NotificationManager.success(res.message);
                      
                      setTimeout(function () {
                          window.location.reload();
                      }, 2000);
                      
                  } else {
                      
                      NotificationManager.error(res.message);
                  }
              });
          }
     }
  


    getTotal = (vertical, location='') => {


      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vertical: vertical,
        location: locationselected,
        searchby:this.state.searchby,
      });

      getTotalPartners(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });


    }  


  sendOTPMail(add_id = '') {
            
        let ins = JSON.stringify({
          login_id: add_id
        });
        findpartnersendotplink(ins).then((res) => {
          if (res.status == 1) {
             alert("Verification code is sent");
             
          } else {
            
             alert("Error sending verfication code");
             return false;
          }
        });

  }    

    handleChangeN = (e) => {
        this.setState({ [e.target.name]: e.target.value });

        localStorage.setItem("location",e.target.value);
        
    }    

    filterShow  = async () => {

      const { login_id, role } = this.state.auth_data;
      let ins = JSON.stringify({
        login_id: login_id,
        role: role,
        location: this.state.location,
        keyword:this.state.keyword,
        year: this.state.year,
        month: this.state.month,
      });
      getPartnerPaged(ins).then((res) => {
        if (res.status == 1) {
          this.setState({
            partnerList: res.data
            
          });
        } else {
          this.setState({
            partnerList: [],
          });
        }
      });

      let instotal = JSON.stringify({
        vertical: 'partners',
        location: this.state.location,
        searchby:this.state.keyword
      });

      getTotalPartners(instotal).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

                  
          this.setState({
            
            total: res.total
            
          });

        } 
      });

    }

 

    getList = (pageNumber=1, location='') => {

      const { login_id, role } = this.state.auth_data;
      
      this.setState({activePage: pageNumber});

      const newOffset = (pageNumber==1)? 0 : (((pageNumber-1) * this.state.PER_PAGE)%this.state.total);

      const locationselected = (location=='')?this.state.location:location;

      let ins = JSON.stringify({
        vendor_id: login_id,
        role: role,
        location: locationselected,
        searchby:this.state.searchby,
        perpage:this.state.PER_PAGE,
        offset:newOffset
      });

      getPartnerPaged(ins).then((res) => {


        this.setState({loading:true});

        if (res.status == 1) {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            
            partnerList: res.data
            
          });

        } else {

          this.setState({loading:!this.state.loading});
          
          this.setState({
            partnerList: [],
          });
        }
      });


    }     


  handlePageChange(pageNumber) {

      console.log(`active page is ${pageNumber}`);

      this.setState({activePage: pageNumber});

      //this.getTotal('bw_schools');
      this.getList(pageNumber);


  }       

    render() {

      
        const { partnerList, exportbtndisabled} = this.state;

        const { eventList, currentPage, PER_PAGE, totalCount, total } = this.state;

        const year = 2019;
        const years = Array.from(new Array(10), (val, index) => index + year);

    
        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Partners</h4>
                                   
                  <div class="float-right"><button disabled={exportbtndisabled} class="btn btn-primary btn-sm"  onClick={() => this.schoolExport()}>{this.state.thisExportBtnText}</button> </div>
                  <p class="card-description">
                    <div class="cityselection">
                     
                      <div class="leftaligned">
                        
                        <select name="location" class="form-control" onChange={(e) => this.handleChangeN(e)}
                                                       value={this.state.location}>
                            <option value="">select city</option>
                            <option value="Bengaluru">Bengaluru</option>
                            <option value="Chennai">Chennai</option>
                            <option value="Indore">Indore</option>
                            <option value="Hosur">Hosur</option>
                            <option value="Coimbatore">Coimbatore</option>
                            <option value="Madurai">Madurai</option>
                            <option value="Mysore">Mysore</option>
                            <option value="Mumbai">Mumbai</option>
                            <option value="Kolkata">Kolkata</option>
                            <option value="New Delhi">New Delhi</option>
                            <option value="Jaipur">Jaipur</option>
                            <option value="Chandigarh">Chandigarh</option>
                            <option value="Pune">Pune</option>
                            <option value="Kochi">Kochi</option>
                            <option value="Indore">Indore</option>
                            <option value="Noida">Noida</option>
                            <option value="Agra">Agra</option>
                            <option value="Puducherry">Puducherry</option>
                            <option value="Tiruchirappalli">Tiruchirappalli</option>
                        </select>

                      </div>

                      <div class="leftaligned">
                      <select className='form-control selectpicker' onChange={this.handleChangeN}
                                                        name='year' title='Select Years' value={this.state.year}>
                                                        <option value={''}>Select Year</option>
                                                        {years.map((item, i) => {
                                                            return (
                                                                <option value={item}>{item}</option>
                                                            )
                                                        })}

                      </select>
                      </div>
                      <div class="leftaligned">
                      <select className='form-control selectpicker' onChange={this.handleChangeN}
                                                        name='month' title='Select Month' value={this.state.month}>
                                                        <option value={''}>Select Month</option>
                                                        {this.state.monthList.map((item, i) => {
                                                            return (
                                                                <option value={item.no}>{item.mon}</option>
                                                            )
                                                        })}
                      </select>
                      </div>
                      <div class="leftaligned">
                       <input type="text" name="keyword" class="form-control" placeholder="Keyword" onChange={this.handleChangeN} />
                      </div>
                      <div class="leftaligned">
                        <button class="btn btn-primary btn-sm" onClick={this.filterShow}>show</button>
                      </div>
                       
                    </div>
                  </p>
                  
                  <div class="table-responsive pt-3">
                   <table id="tablebw">
                      <thead class="thead-dark">
                        <tr>
                          
                          <th>
                            <strong>S.No</strong>
                          </th>
                         
                          <th>
                            <strong>Name</strong>
                          </th>

                          <th>
                            <strong>City</strong>
                          </th>

                           <th>
                            <strong>Email Id</strong>
                          </th>

                          <th>
                            <strong>Type</strong>
                          </th>

                        

                          <th>
                            <strong>Category</strong>
                          </th>
                         
                            <th>
                            <strong>Created on</strong>
                          </th>
                           
                          <th>
                            <strong>Login</strong>
                          </th>

                          <th>
                            <strong>Account Status</strong>
                          </th>

                          <th>
                            <strong>Action</strong>
                          </th>

                        </tr>
                      </thead>
                      <tbody>


                      {partnerList.length>0 && partnerList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
              
                          <td>
                            {item.name}
                          </td>
                          
                          <td>
                            {item.location}
                          </td>

                          <td>
                            {item.email_id}
                          </td>

                          <td>
                            {item.user_type}
                          </td>
                          
                          <td>
                            {item.category_name}
                          </td>

                          <td>
                            {item.created_date}
                          </td>

                           

                          <td className={item.is_active==1 ?"green": (item.is_active==3) ? "orange" : "red"}>{item.is_active==1?"Active": (item.is_active==3) ? "Deactivated": "Inactive"}</td> 
                          
                          <td dangerouslySetInnerHTML={{__html: item.status}} />
                                                       
                          <td class="actionbtns" dangerouslySetInnerHTML={{__html: item.action}} />

                        </tr>

                      })

                      }

                      {partnerList.length==0 && 

                        <tr><td colspan="9">No data</td></tr>

                        
                      }
                       
                      </tbody>
                       
                    </table>


                    <div class="text-center">
                      
                     <Pagination
                        activePage={this.state.activePage}
                        itemsCountPerPage={PER_PAGE}
                        totalItemsCount={this.state.total}
                        pageRangeDisplayed={5}
                        activeClass={"pagination__link--active"}
                        onChange={this.handlePageChange.bind(this)}
                        prevPageText="previous"
                        nextPageText="next"
                      />

                    </div>


                  </div>
                </div>
              </div>
            </div>

              <Modal isOpen={this.state.confirmModal} className=''>
              <form>
                  <div className='modal-header text-center'>
                      <div className='row'>
                          <div className="col-md-12">
                              <h3>Extend Expire Date</h3>
                          </div>
                      </div>
                  </div>
                  <ModalBody className=''>
                      <div className='row pad-all'>
                          <div className="form-group col-md-6">
                              <label>Current Expire Date<span className="astrick">*</span></label>
                              <DatePicker
                                  autocomplete="off"
                                  className='form-control input-group-date'
                                  selected={this.state.expire_date}
                                  name="expire_date"
                                  id="expire_date"
                                  dateFormat="MMMM d, yyyy"
                                  disabled="disabled"
                                  required
                              />
                          </div>
                          <div className="form-group col-md-6">
                              <label>Choose Extend Month<span className="astrick">*</span></label>
                              <select className="form-control" onChange={this.handleMonth} name="add_month">
                                  <option value="">Select Month</option>
                                  <option value="3">3 Months</option>
                                  <option value="6">6 Months</option>
                                  <option value="9">9 Months</option>
                              </select>
                          </div>
                          <div className="form-group col-md-6">
                              <label>New Expire Date<span className="astrick">*</span></label>
                              <DatePicker
                                  autocomplete="off"
                                  className='form-control input-group-date'
                                  selected={this.state.new_date}
                                  name="new_date"
                                  id="new_date"
                                  dateFormat="MMMM d, yyyy"
                                  disabled="disabled"
                                  required
                              />
                          </div>
                      </div>
                  </ModalBody>
                  <ModalFooter>
                      <div className='row'>
                          <div className='col-md-12 pull-right'>
                              <button className='btn btn-sm btn-default' onClick={this.cancelPop}>No</button>
                              <button type='submit' className='btn btn-sm btn-success' onClick={this.updateExpire}>Yes</button>

                          </div>
                      </div>

                  </ModalFooter>
              </form>
          </Modal>


            <NotificationContainer />     
                </AdminLayout>
            </React.Fragment>
        )
    }

    handleChange = (date) => {
      console.log('value', date)
      this.setState({ expire_date: date });
  }
  handleMonth = (e) => {
      let months = e.target.value;
      let cur_date = new Date($('#expire_date').val());
      let newdate = new Date(cur_date.setMonth(cur_date.getMonth() + parseInt(months)));
      this.setState({
          new_date: newdate
      });
      // console.log('value', date)
      // this.setState({ new_date: date });
  }

    updateExpire = (e) => {
      e.preventDefault();
      let req = JSON.stringify({
          vendor_id: this.state.vendor_id,
          expire_date: this.state.new_date,
          url: 'updateExpire'
      });
      partnerApi(req).then(res => {
          //let toastr = '';
          if (res.status === 1) {
              //toastr = window.toastr.success;
              setTimeout(function () {
                  window.location.reload();
              }, 1000);
          } else {
              //toastr = window.toastr.error;
          }
          
      })
  }
}


export default partnerList;


// WEBPACK FOOTER //
// ./src/components/bewise/partnerList.jsx